export function initSegmentSelectors() {
    // handle the weird segment selector
    document.querySelectorAll('select.segment-select').forEach(function (select) {
        select.addEventListener('change', function () {
            onSegmentChange(select);
        });
        
        updateSegmentSelection(select);
    });
}

function onSegmentChange(selectElement) {
    const selected = selectElement.value;
    const segmentMultiple = selectElement.closest('div').querySelector('.segment-select-multiple');

    // Select or deselect the option in segmentMultiple
    if (segmentMultiple) {
        for (let i = 0; i < segmentMultiple.options.length; i++) {
            if (segmentMultiple.options[i].value === selected) {
                segmentMultiple.options[i].selected = !segmentMultiple.options[i].selected;
                break;
            }
        }

        // Trigger change event so listeners can react
        segmentMultiple.dispatchEvent(new Event('change', { bubbles: true }));

        // Update the select's text to show the count of selected segments
        updateSegmentSelection(selectElement);
    }
}

function updateSegmentSelection(selectElement) {
    const segmentMultiple = selectElement.closest('div').querySelector('.segment-select-multiple');
    const segmentList = selectElement.closest('div').querySelector('.segment-list');
    if (!segmentMultiple || !segmentList) return;

    const count = Array.from(segmentMultiple.selectedOptions).length;

    // Reset the select to the first option
    selectElement.selectedIndex = 0;

    // Update the select text
    if (selectElement && selectElement.options.length > 0) {
        selectElement.options[0].text = count > 0 ? `${count} Selected` : "-- Select --";
    }

    // Create the pills
    segmentList.innerHTML = '';
    Array.from(segmentMultiple.selectedOptions).forEach(option => {
        const div = document.createElement('div');
        div.classList.add('segment-pill');
        div.dataset.segment = option.value;

        const span = document.createElement('span');
        span.textContent = option.text;
        div.appendChild(span);

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.classList.add('segment-pill__remove');
        btn.textContent = '×';
        btn.addEventListener('click', () => {
            option.selected = false;
            // Trigger change event so listeners can react
            segmentMultiple.dispatchEvent(new Event('change', { bubbles: true }));
            updateSegmentSelection(selectElement);
        });
        div.appendChild(btn);

        segmentList.appendChild(div);
    });
}
